import { render, staticRenderFns } from "./AInspectionRoutePoint.vue?vue&type=template&id=3f06f168&scoped=true"
import script from "./AInspectionRoutePoint.vue?vue&type=script&lang=js"
export * from "./AInspectionRoutePoint.vue?vue&type=script&lang=js"
import style0 from "./AInspectionRoutePoint.vue?vue&type=style&index=0&id=3f06f168&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f06f168",
  null
  
)

export default component.exports